export default __webpack_public_path__ + "static/media/pink_anim.e26373b5.gif";